<template>
  <div class="col-12 col-lg-6">
    <div class="tit text-center">
      <h1>Escolaridade</h1>
    </div>
    <div class="row justify-content-center">
      <div class="col-12 col-md-10 col-lg-8 col-xl-7">
        <form @submit="onSubmit">
          <div class="form-group text-left">
            <label for="Escolaridade">
              Escolaridade
            </label>
            <at-select v-model="currentUser.Pessoal.Escolaridade" filterable size="large" required placeholder="Selecione...">
              <at-option v-for="(degree, index) in degrees" :key="`degreesOptions${index}`" :value="degree.value">{{degree.label}}</at-option>
            </at-select>
          </div>
          <div class="text-center fixedOptions">
            <button class="btn btn-primary">Próximo <img src="../../assets/images/angle-right.svg"></button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      degrees : [
        {value: 1, label: 'Ensino Fundamental Incompleto'},
        {value: 2, label: 'Ensino Fundamental Completo'},
        {value: 3, label: 'Ensino Médio Incompleto'},
        {value: 5, label: 'Ensino Médio Completo'},
        {value: 6, label: 'Ensino Superior Incompleto'},
        {value: 7, label: 'Ensino Superior Completo'},
        {value: 8, label: 'Pós – graduação'},
      ]
    }
  },
  props: {
    currentUser: {required: true, type: Object}
  },
  methods: {
    onSubmit(e) {
      e.preventDefault()
      this.$emit('on-submit', {Pessoal: this.currentUser.Pessoal})
    }
  },
  mounted() {
    document.getElementsByClassName("at-select__input")[0].setAttribute("required", "");
  }
}
</script>




// WEBPACK FOOTER //
// src/components/AdditionalInformationPersonalLoan/ScholarityStep.vue